import * as React from "react";
import {
  Box,
  Tabs,
  Tab,
  Stack,
  Typography,
  Chip,
  Button,
  Grid,
  Avatar,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import PropTypes from "prop-types";
import States from "../State";
import StatePopup from "../StatePopup";
import { useTranslation } from "react-i18next";
// import "./index.scss";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

function BootstrapDialogTitle(props) {
  const { children, onClose, ...other } = props;
  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
}

BootstrapDialogTitle.propTypes = {
  children: PropTypes.node,
  onClose: PropTypes.func.isRequired,
};
export default function MapPopup({ open, handleClose, location }) {
  const { t } = useTranslation("common");
  return (
    <div>
      <BootstrapDialog
        open={open}
        onClose={() => handleClose(false)}
        PaperProps={{
          style: {
            // background: "#262626",
            background: "#171515",
            width: "100%",
            paddingBottom: "20px",
          },
        }}
      >
        <BootstrapDialogTitle
          id="customized-dialog-title"
          onClose={() => handleClose(false)}
          sx={{ borderBottom: "2px solid #1E1E1E" }}
        >
          {t("allCountry")}
        </BootstrapDialogTitle>
        <DialogContent>
          <Box
            sx={{
              maxHeight: "70vh",
              // background: "#262626",
              background: "#171515",
            }}
          >
            <StatePopup location={location} />
          </Box>
        </DialogContent>
      </BootstrapDialog>
    </div>
  );
}
